import React, { useEffect, useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Container,
  Card,
  CardBody,
} from "reactstrap";

import "./stock.css";
import { createStock } from "../../api/stock/addStockApi";
import { getPlants } from "../../api/processing plant/plantApi";
import { getCouriers } from "../../api/courier/courierApi";
import { getAuthToken } from "../../api/stock/addStockApi.js";
import { TextField } from "@mui/material"; // Corrected import
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

import { getStockById } from "./../../api/stock/getStockById";
import { useParams } from "react-router-dom";

const validationSchema = Yup.object({
  // Stock_id: Yup.string().required('Stock id is required'),
  Product_Name: Yup.string().required('Product Name is required'),
  Last_Date_Of_Catch: Yup.date()
    .required('Last Date Of Catch is required')
    .typeError('Invalid date format'),
  Last_Catch_Location: Yup.string()
    .required('Last Catch Location is required')
    .matches(
      /^-?\d+(\.\d+)?,\s*-?\d+(\.\d+)?$/,
      'Please enter a valid format: latitude, longitude'
    ),
  Boat_Number: Yup.string().required('Boat Number is required'),
  Scientific_Name: Yup.string().required('Scientific Name is required'),
  Fishing_Method: Yup.string().required('Fishing Method is required'),

  Quality_Grade: Yup.string().required('Quality Grade is required'),
  Price_per_Kg: Yup.number()
    .positive('Must be a positive number')
    .required('Price per Kg is required'),
  Minimum_Order_Quantity: Yup.number()
    .positive('Must be a positive number')
    .required('Minimum Order Quantity is required'),
  Total_Available_Quantity: Yup.number()
    .positive('Must be a positive number')
    .required('Total Available Quantity is required'),

  Harbour: Yup.string().required('Harbour is required'),
});

const StyledProductForm = () => {
  const { stockId } = useParams();
  const [plants, setPlants] = useState([]);
  const [stockData, setStockData] = useState([]);

  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchPlants = async () => {
      try {
        const response = await getPlants(); // Fetch data
        console.log(response.data);
        setPlants(response.data); // Set data to state
      } catch (error) {
        console.error('Error fetching plants:', error);
      }
    };

    fetchPlants();
  }, []);

  const [couriers, setCouriers] = useState([]);

  useEffect(() => {
    const fetchCouriers = async () => {
      try {
        const response = await getCouriers(); // Fetch data
        console.log(response.data.data);
        setCouriers(response.data.data); // Set data to state
      } catch (error) {
        console.error('Error fetching plants:', error);
      }
    };

    fetchCouriers();
  }, []);

  useEffect(() => {
    const fetchStock = async () => {
      try {
        const pathParts = window.location.pathname.split('/');
        const id = pathParts[pathParts.length - 1]; // Extract ID from URL

        if (id) {
          const response = await getStockById(id); // Fetch data
          console.log(response.data.data); // Log response
          setData(response.data.data); // Set data to state
        }
      } catch (error) {
        console.error('Error fetching stock data:', error);
      }
    };

    fetchStock();
  }, []);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      Stock_id: 'BFT001',
      Trip_Number: '123455',
      Product_Name: '',
      Description: '',
      Boat_Owner_Number: '123',
      Boat_Number: '',
      Last_Date_Of_Catch: '',
      Last_Catch_Location: '',
      Harbour: '',
      Scientific_Name: '',
      Fishing_Method: '',
      Size_Weight: '10',
      Quality_Grade: '',
      Price_per_Kg: '',
      Minimum_Order_Quantity: '',
      Total_Available_Quantity: '',
      Sustainability_Certification: 'No',
      Courier_id: '',
      Status: 'Pending',
      EPT: 0,
      EDT: 0,
    },
    validationSchema: validationSchema,
    onSubmit: async (initialValues, { setSubmitting }) => {
      const minOrder = Number(initialValues.Minimum_Order_Quantity);
      const totalQty = Number(initialValues.Total_Available_Quantity);
      if (minOrder > totalQty) {
        await Swal.fire({
          icon: 'error',
          title: 'Invalid Quantity',
          text: 'Minimum Order Quantity cannot exceed Total Available Quantity.',
        });
        setSubmitting(false);
        return;
      }
      // ...existing code...
      console.log(initialValues);
      const token = await getAuthToken();
      console.log(token);
      try {
        const response = await axios.post(
          'https://api.starmarketapi.online/stock_details/v1/stocks/upsert1', // your backend route or direct API route
          initialValues, // request body
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
        console.log('Form submitted successfully:', response.data);
        if (response.data.message === 'Stock updated successfully') {
          Swal.fire({
            title: 'Stock Added Successfully!',
            html: `
                <div style="text-align: left; font-size:0.9rem; margin-top:30px">
                    <p style="color:gray;">Product Name</p>
                    <p><b>${initialValues.Product_Name || 'N/A'}</b></p>
                    <hr>
                    <p style="color:gray;">Total Quantity</p>
                    <p><b>${
                      initialValues.Total_Available_Quantity || 'N/A'
                    } KG</b></p>
                    <hr>
                    <p style="color:gray;">Price Per Kg</p>
                    <p><b>LKR ${initialValues.Price_per_Kg || 'N/A'}/kg</b></p>
                    <hr>
                    <p style="color:gray;">Catch Date</p>
                    <p><b>${initialValues.Last_Date_Of_Catch || 'N/A'}</b></p>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Back',
            cancelButtonText: 'Home page',
            confirmButtonColor: '#000',
            cancelButtonColor: 'gray',
            customClass: {
              popup: 'swal-custom-popup', // Custom class for styling
            },
          }).then((result) => {
            if (result.isConfirmed) {
              // Redirect to BoatOwnerDashboard My Stock tab
              localStorage.setItem('boatOwnerActiveTab', 'Stocks');
              window.location.href = '/BoatOwnerDashboard';
            } else {
              // Redirect to home page
              window.location.href = '/';
            }
          });
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    },
  });

  useEffect(() => {
    if (data) {
      formik.setValues({
        _id: data._id,
        Stock_id: data.Stock_id || '',
        Trip_Number: data.Trip_Number || '',
        Product_Name: data.Product_Name || '',
        Description: data.Description || '',
        Boat_Owner_Number: data.Boat_Owner_Number || '',
        Boat_Number: data.Boat_Number || '',
        Last_Date_Of_Catch: data.Last_Date_Of_Catch
          ? new Date(data.Last_Date_Of_Catch)
          : null, // Ensure it's a Date object
        Last_Catch_Location: data.Last_Catch_Location || '',
        Harbour: data.Harbour || '',
        Scientific_Name: data.Scientific_Name || '',
        Fishing_Method: data.Fishing_Method || '',
        Size_Weight: data.Size_Weight || '',
        Quality_Grade: data.Quality_Grade || '',
        Price_per_Kg: data.Price_per_Kg || '',
        Minimum_Order_Quantity: data.Minimum_Order_Quantity || '',
        Total_Available_Quantity: data.Size_Weight || '',
        Sustainability_Certification: data.Sustainability_Certification || 'No',
        Status: data.Status || 'Pending',
        EPT: data.EPT || 0,
        EDT: data.EDT || 0,
      });
    }
  }, [data]); // Runs when `data` updates

  const steps = [
    {
      label: 'Basic Details',
      fields: ['Boat_Number', 'Harbour', 'Fishing_Method', 'Description'],
    },
    {
      label: 'Product Specifications',
      fields: ['Product_Name', 'Scientific_Name', 'Quality_Grade'],
    },
    {
      label: 'Catch Details',
      fields: [
        'Last_Date_Of_Catch',
        'Last_Catch_Location',
        'Total_Available_Quantity',
      ],
    },
    {
      label: 'Pricing & Logistics',
      fields: ['Price_per_Kg', 'Minimum_Order_Quantity'],
    },
  ];

  const [step, setStep] = useState(0);

  const nextStep = async () => {
    const fieldsToValidate = steps[step].fields;

    // Manually trigger validation
    await formik.setTouched(
      fieldsToValidate.reduce((acc, field) => ({ ...acc, [field]: true }), {}),
      true
    );

    const errors = await formik.validateForm(); // Validate entire form

    // Check if there are errors in the current step
    const hasErrors = fieldsToValidate.some((field) => errors[field]);

    if (!hasErrors) {
      setStep((prev) => Math.min(prev + 1, steps.length - 1));
    }
  };

  const prevStep = () => setStep((prev) => Math.max(prev - 1, 0));

  const renderField = (field) => {
    const fieldType = field.includes('Date') ? 'date' : 'text';
    const fieldValue = formik.values[field] || '';

    // Special handling for Boat_Number (select field)
    if (field === 'Boat_Number') {
      return (
        <FormGroup key={field}>
          <TextField
            label={field
              .replace(/_/g, ' ') // Replace underscores with spaces
              .replace(/^./, (str) => str.toUpperCase())}
            variant="outlined"
            type="text"
            id={field}
            name={field}
            list="vesselNumbers"
            value={fieldValue}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={!!(formik.touched[field] && formik.errors[field])} // Changed 'invalid' to 'error'
            helperText={
              formik.touched[field] && formik.errors[field]
                ? formik.errors[field]
                : ''
            }
            InputProps={{
              readOnly: true, // Make the field read-only
            }}
            sx={{
              backgroundColor: 'rgb(255, 255, 255)',
              borderRadius: '20px',
              width: '100%',
              '& .MuiOutlinedInput-root': {
                borderRadius: '20px',
              },
            }}
          />
        </FormGroup>
      );
    }

    if (field === 'Total_Available_Quantity') {
      return (
        <FormGroup key={field}>
          <TextField
            label={field
              .replace(/_/g, ' ') // Replace underscores with spaces
              .replace(/^./, (str) => str.toUpperCase())} // Capitalize the first letter
            variant="outlined"
            type="text"
            id={field}
            name={field}
            value={fieldValue}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={!!(formik.touched[field] && formik.errors[field])} // Changed 'invalid' to 'error'
            helperText={
              formik.touched[field] && formik.errors[field]
                ? formik.errors[field]
                : ''
            }
            InputProps={{
              readOnly: true, // Make the field read-only
            }}
            sx={{
              backgroundColor: 'rgb(255, 255, 255)',
              borderRadius: '20px',
              width: '100%',
              '& .MuiOutlinedInput-root': {
                borderRadius: '20px',
              },
            }}
          />
        </FormGroup>
      );
    }

    if (field === 'Last_Catch_Location') {
      return (
        <FormGroup key={field}>
          <TextField
            label={field
              .replace(/_/g, ' ') // Replace underscores with spaces
              .replace(/^./, (str) => str.toUpperCase())} // Capitalize the first letter
            variant="outlined"
            type="text"
            id={field}
            name={field}
            value={fieldValue}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={!!(formik.touched[field] && formik.errors[field])} // Changed 'invalid' to 'error'
            helperText={
              formik.touched[field] && formik.errors[field]
                ? formik.errors[field]
                : ''
            }
            InputProps={{
              readOnly: true, // Make the field read-only
            }}
            sx={{
              backgroundColor: 'rgb(255, 255, 255)',
              borderRadius: '20px',
              width: '100%',
              '& .MuiOutlinedInput-root': {
                borderRadius: '20px',
              },
            }}
          />
        </FormGroup>
      );
    }

    if (field === 'Last_Date_Of_Catch') {
      return (
        <FormGroup key={field}>
          <TextField
            label={field
              .replace(/_/g, ' ') // Replace underscores with spaces
              .replace(/^./, (str) => str.toUpperCase())}
            variant="outlined"
            type="datetime-local"
            id={field}
            name={field}
            value={
              fieldValue instanceof Date
                ? fieldValue.toISOString().slice(0, 16)
                : fieldValue
            }
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={!!(formik.touched[field] && formik.errors[field])} // Changed 'invalid' to 'error'
            helperText={
              formik.touched[field] && formik.errors[field]
                ? formik.errors[field]
                : ''
            }
            InputProps={{
              readOnly: true, // Make the field read-only
            }}
            sx={{
              backgroundColor: 'rgb(255, 255, 255)',
              borderRadius: '20px',
              width: '100%',
              '& .MuiOutlinedInput-root': {
                borderRadius: '20px',
              },
            }}
          />
        </FormGroup>
      );
    }

    if (field === 'Product_Name') {
      return (
        <FormGroup key={field}>
          <TextField
            label={field
              .replace(/_/g, ' ') // Replace underscores with spaces
              .replace(/^./, (str) => str.toUpperCase())} // Capitalize the first letter
            variant="outlined"
            type="text"
            id={field}
            name={field}
            value={fieldValue}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={!!(formik.touched[field] && formik.errors[field])} // Changed 'invalid' to 'error'
            helperText={
              formik.touched[field] && formik.errors[field]
                ? formik.errors[field]
                : ''
            }
            InputProps={{
              readOnly: true, // Make the field read-only
            }}
            sx={{
              backgroundColor: 'rgb(255, 255, 255)',
              borderRadius: '20px',
              width: '100%',
              '& .MuiOutlinedInput-root': {
                borderRadius: '20px',
              },
            }}
          />
        </FormGroup>
      );
    }

    if (field === 'Fishing_Method') {
      return (
        <FormGroup key={field}>
          <FormControl
            fullWidth
            variant="outlined"
            sx={{
              backgroundColor: 'rgb(255, 255, 255)',
              borderRadius: '20px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '20px',
              },
            }}
            error={!!(formik.touched[field] && formik.errors[field])}
          >
            {/* Properly linked InputLabel */}
            <InputLabel id={`${field}-label`}>
              {field
                .replace(/_/g, ' ') // Replace underscores with spaces
                .replace(/^./, (str) => str.toUpperCase())}
            </InputLabel>

            <Select
              labelId={`${field}-label`}
              id={field}
              name={field}
              value={fieldValue}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label={field
                .replace(/_/g, ' ') // Replace underscores with spaces
                .replace(/^./, (str) => str.toUpperCase())} // Ensure label moves correctly
            >
              <MenuItem value="">Select Fishing Method</MenuItem>
              <MenuItem value="Hand Gathering">Hand Gathering</MenuItem>
              <MenuItem value="Spearfishing">Spearfishing</MenuItem>
              <MenuItem value="Handline Fishing">Handline Fishing</MenuItem>
              <MenuItem value="Cast Net Fishing">Cast Net Fishing</MenuItem>
              <MenuItem value="Gillnetting">Gillnetting</MenuItem>
              <MenuItem value="Traps and Pots">Traps and Pots</MenuItem>
              <MenuItem value="Pole and Line Fishing">
                Pole and Line Fishing
              </MenuItem>
              <MenuItem value="Trawling">Trawling</MenuItem>
              <MenuItem value="Purse Seining">Purse Seining</MenuItem>
              <MenuItem value="Longlining">Longlining</MenuItem>
              <MenuItem value="Drift Net Fishing">Drift Net Fishing</MenuItem>
              <MenuItem value="Bottom Trawling">Bottom Trawling</MenuItem>
              <MenuItem value="Electrofishing">Electrofishing</MenuItem>
              <MenuItem value="Dynamite Fishing (Illegal)">
                Dynamite Fishing (Illegal)
              </MenuItem>
              <MenuItem value="Poison Fishing (Illegal)">
                Poison Fishing (Illegal)
              </MenuItem>
            </Select>

            {formik.touched[field] && formik.errors[field] && (
              <FormHelperText>{formik.errors[field]}</FormHelperText>
            )}
          </FormControl>
        </FormGroup>
      );
    }

    if (field === 'Harbour') {
      return (
        <FormGroup key={field}>
          <FormControl
            fullWidth
            variant="outlined"
            sx={{
              backgroundColor: 'rgb(255, 255, 255)',
              borderRadius: '20px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '20px',
              },
            }}
            error={!!(formik.touched[field] && formik.errors[field])}
          >
            {/* Correct InputLabel for the Select field */}
            <InputLabel id={`${field}-label`}>
              {field
                .replace(/_/g, ' ') // Replace underscores with spaces
                .replace(/^./, (str) => str.toUpperCase())}
            </InputLabel>

            <Select
              labelId={`${field}-label`}
              id={field}
              name={field}
              value={fieldValue}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label={field
                .replace(/_/g, ' ') // Replace underscores with spaces
                .replace(/^./, (str) => str.toUpperCase())} // Ensures correct label positioning
            >
              <MenuItem value="">Select Harbour</MenuItem>
              <MenuItem value="Beruwala">Beruwala</MenuItem>
              <MenuItem value="Chilaw">Chilaw</MenuItem>
              <MenuItem value="Dikkowita">Dikkowita</MenuItem>
              <MenuItem value="Gandara">Gandara</MenuItem>
              <MenuItem value="Hikkaduwa">Hikkaduwa</MenuItem>
              <MenuItem value="Kalmunai">Kalmunai</MenuItem>
              <MenuItem value="Karainagar">Karainagar</MenuItem>
              <MenuItem value="Kirinda">Kirinda</MenuItem>
              <MenuItem value="Kudawella">Kudawella</MenuItem>
              <MenuItem value="Mannar">Mannar</MenuItem>
              <MenuItem value="Mirissa">Mirissa</MenuItem>
              <MenuItem value="Mullaitivu">Mullaitivu</MenuItem>
              <MenuItem value="Negombo">Negombo</MenuItem>
              <MenuItem value="Oluvil">Oluvil</MenuItem>
              <MenuItem value="Panadura">Panadura</MenuItem>
              <MenuItem value="Puranawella">Puranawella</MenuItem>
              <MenuItem value="Tangalle">Tangalle</MenuItem>
              <MenuItem value="Trincomalee">Trincomalee</MenuItem>
              <MenuItem value="Valvettithurai">Valvettithurai</MenuItem>
            </Select>

            {formik.touched[field] && formik.errors[field] && (
              <FormHelperText>{formik.errors[field]}</FormHelperText>
            )}
          </FormControl>
        </FormGroup>
      );
    }

    // Default input field for other fields
    return (
      <FormGroup key={field}>
        <TextField
          label={field
            .replace(/_/g, ' ') // Replace underscores with spaces
            .replace(/^./, (str) => str.toUpperCase())}
          variant="outlined"
          type={fieldType}
          id={field}
          name={field}
          value={fieldValue}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={!!(formik.touched[field] && formik.errors[field])} // Changed 'invalid' to 'error'
          helperText={
            formik.touched[field] && formik.errors[field]
              ? formik.errors[field]
              : ''
          }
          sx={{
            backgroundColor: 'rgb(255, 255, 255)',
            borderRadius: '20px',
            width: '100%',
            '& .MuiOutlinedInput-root': {
              borderRadius: '20px',
            },
          }}
        />
      </FormGroup>
    );
  };

  return (
    <React.Fragment>
      <section
        className="section bg-light"
        style={{ paddingTop: '80px' }}
      >
        <Container
          fluid
          className="gaps"
        >
          <Row>
            <Col
              md={3}
              style={{ marginBottom: '10px' }}
            >
              <div className="sidebar">
                <div className="card wishlist-header p-3">
                  <h5>Steps</h5>
                  <p>Fresh Yellowfin Tuna Lorem</p>
                </div>
                <div className="step-container">
                  {steps.map((s, index) => (
                    <div
                      key={index}
                      className={`step-item ${index === step ? 'active' : ''} ${
                        index < step ? 'completed' : ''
                      }`}
                    >
                      <div className="step-circle">
                        {index === step ? (
                          <i className="fa fa-spinner fa-spin"></i>
                        ) : (
                          '✔'
                        )}
                      </div>
                      <div className="step-label">{s.label}</div>
                      {index !== steps.length - 1 && (
                        <div className="step-line"></div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </Col>
            <Col md={9}>
              <Card className="form-card">
                <CardBody>
                  <h5>{steps[step].label}</h5>
                  <Form>
                    <Row>
                      {steps[step].fields.map((field) => (
                        <Col
                          md={6}
                          key={field}
                        >
                          {renderField(field)}
                        </Col>
                      ))}
                    </Row>
                    <br />
                    <br />
                    <hr />
                    {data && (
                      <div className="button-group flex gap-4">
                        {step > 0 && <Button onClick={prevStep}>Back</Button>}
                        {step === steps.length - 1 ? (
                          <Button
                            color="primary"
                            onClick={formik.handleSubmit}
                          >
                            Submit
                          </Button>
                        ) : (
                          <Button
                            color="primary"
                            onClick={nextStep}
                          >
                            Next
                          </Button>
                        )}
                      </div>
                    )}
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default StyledProductForm;
